import Vue from 'vue'
import {
    AclRule
} from 'vue-acl'

import Router from 'vue-router'
import store from './store/store'
import LoginPage from './components/login.vue'
import DashboardPage from './components/dashboard.vue'
import Overview from './components/overview'

import PromotionCreatePage from './components/promotion/create.vue'
import PromotionManagePage from './components/promotion/manage.vue'
import PromotionTrackPage from './components/promotion/track.vue'
import PromotionReportPage from './components/promotion/report.vue'

import CampaignCreatePage from './components/campaign/create.vue'
import CampaignManagePage from './components/campaign/manage.vue'
import CampaignRewardPage from './components/campaign/rewardPage.vue'
import CampaignTrackPage from './components/campaign/track.vue'
import CampaignRepotPage from './components/campaign/Report.vue'
import CampaignConfig from './components/campaign/Config.vue'

import SettingMyAccountPage from './components/setting/myaccount.vue'
// import SettingUserManagementPage from './components/setting/usermanage.vue'
import SettingAboutPage from './components/setting/about.vue'

import CustomerGroup from './components/system/customer-group.vue'

// Pricing
import VolumePricingPage from './components/pricing/volume-pricing.page'
import ProductsPage from './components/pricing/products.page'
import PricingListPage from './components/pricing/pricing-list.page'
import VolumePricingReportPage from './components/pricing/report.vue'
import BookPricePage from './components/pricing/book-price.vue'
import RequestPricePage from './components/pricing/bookprice/request-price.vue'
import MessagePage from './components/pricing/bookprice/message.vue'

import DefaultLayout from './components/layout/default'

import publicPage from './components/test/publicPage'
import adminPage from './components/test/adminPage'

import PageNotFound from './components/pageNotFound.vue'
import AccessDenied from './components/accessDenied.vue'
import MaintenancePage from './components/maintenance.vue'

import Users from './components/system/users';
import ConfigSystem from './components/system/set-config';
//import firebase from 'firebase'

import aclMap from './acl-map'

Vue.use(Router)

const routes = new Router({
    // mode: 'history', /* for report of SalesOps (path: '/mkt/analize') */
    routes: [{
        path: '/login',
        component: LoginPage,
        meta: {
            rule: 'isPublic',
        }
    },
    {
        path: '/retest',
        component: LoginPage,
        meta: {
            rule: 'isPublic',
        }
    },
    {
        path: '/maintenance',
        component: MaintenancePage,
        meta: {
            rule: 'isPublic',
        }
    },
    // {
    //     path: '/retest',
    //     component: LoginPage,
    //     meta: {
    //         rule: 'isPublic',
    //     }
    // },
    {
        path: '/',
        component: DefaultLayout,
        children: [{
            path: '/overview',
            component: Overview,
            meta: {
                rule: 'isPublic',
                auth: true,
                skipAcl: true
            }
        },
        {
            path: '/public',
            component: publicPage,
            meta: {
                rule: new AclRule('public').generate()
            }
        },
        {
            path: '/admin',
            component: adminPage,
            meta: {
                rule: new AclRule('admin').generate()
            }
        },
        {
            path: '',
            component: DashboardPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/pricing/products',
            component: ProductsPage,
            meta: {
                rule: 'isPublic',
                auth: true,
            }
        },
        {
            path: '/overview/products',
            component: ProductsPage,
            meta: {
                rule: 'isPublic',
                auth: true,
            }
        },
        {
            path: '/pricing/pricing-list',
            component: PricingListPage,
            meta: {
                rule: 'isPublic',
                auth: true,
            }

        },
        {
            path: '/overview/pricing-list',
            component: PricingListPage,
            meta: {
                rule: 'isPublic',
                auth: true,
            }

        },
        {
            path: '/pricing/volume-pricing',
            component: VolumePricingPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/overview/volume-pricing',
            component: VolumePricingPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/overview/book-price',
            component: BookPricePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/overview/request-price',
            component: RequestPricePage,
            meta: {
                rule: 'isPublic',
                auth: false
            }
        },
        {
            path: '/overview/message',
            component: MessagePage,
            meta: {
                rule: 'isPublic',
                auth: false
            }
        },
        {
            path: '/overview/report',
            component: VolumePricingReportPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/promotion/create',
            component: PromotionCreatePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/promotion/manage/:id',
            component: PromotionManagePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/promotion/manage',
            component: PromotionManagePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/promotion/track',
            component: PromotionTrackPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/mkt/analize',
            component: PromotionReportPage,
            meta: { auth: true }
        },
        {
            path: '/salesops',
            component: PromotionReportPage,
            meta: { auth: true }
        },
        {
            path: '/promotion/report',
            component: PromotionReportPage,
            meta: { auth: true }
        },
        {
            path: '/campaign/create',
            component: CampaignCreatePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/campaign/manage',
            component: CampaignManagePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/campaign/reward',
            component: CampaignRewardPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/campaign/track',
            // component: CampaignTrackPage, 
            component: CampaignRepotPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/campaign/config',
            // component: CampaignTrackPage, 
            component: CampaignConfig,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/setting/myaccount',
            component: SettingMyAccountPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/setting/about',
            component: SettingAboutPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/system/customer-group',
            component: CustomerGroup,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/system/users',
            component: Users,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/system/set-config',
            component: ConfigSystem,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/setting/customer-group',
            component: CustomerGroup,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/setting/users',
            component: Users,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/setting/set-config',
            component: ConfigSystem,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        // {
        //     path: '/maintenance',
        //     component: MaintenancePage,
        // },
        {
            path: '/accessDenied',
            component: AccessDenied,
            meta: {
                rule: '*'
            }
        },
        {
            path: "*",
            component: PageNotFound
        },
        ]
    },
        // { path: "*", component: DashboardPage }
    ]
})

routes.beforeEach((to, from, next) => {

    // AUTH CHECK
    if (to.matched.some(route => route.meta.auth)) {
      if (!store.state.auth.isLoggedIn) {
        return next('/login')
      }
    }
  
    // SERVER STATUS
    // const status = localStorage.getItem('setStatusServer')
  
    // SPECIAL ROUTE SIDE EFFECT
    if (to.path === '/overview/request-price') {
      store.commit('bookprice/onClickRequestPage', true)
    }
  
    if (to.path !== '/overview/pricing-list') {
      localStorage.removeItem('click_book_price')
    }
  
    // SKIP ACL ROUTES
    if (
      ['/login', '/', '/maintenance', '/retest'].includes(to.path)
    ) {
      return next()
    }
  
    // ACL CHECK
    const rule = aclMap[to.path]
  
    if (!rule) {
      return next()
    }
  
    const token = localStorage.getItem('token')
    if (!token) {
      return next('/login')
    }
  
    let acl = {}
    try {
        const decoded = Vue.$jwt.decode(token)
        acl = decoded && decoded.acl ? decoded.acl : {}
    } catch (e) {
        return next('/login')
    }
    
    const { module, menu } = rule
    
    if (
        !acl[module] ||
        !acl[module].menus ||
        !acl[module].menus[menu] ||
        acl[module].menus[menu].view !== true
    ) {
        return next('/accessDenied')
    }
  
    return next()
  })
  


export default routes
